import React from 'react';
import { NavLink } from 'react-router-dom';
import { IRoute } from '../../config/appRoutes';
import { useTranslation } from 'react-i18next';
import { ROUTES_NS } from '../../routes/i18n';
import { useTheme } from '@mui/system';
import Stack from '@mui/material/Stack';

interface AppNavListProps {
  appRoutes: IRoute[];
}

// Define a type for the translation keys
export type TranslationKeys =
  | 'bunkeringDashboard'
  | 'mfmComparison'
  | 'bunkeringLogs'
  | 'alarmLogs';

export const AppNavList: React.FC<AppNavListProps> = ({ appRoutes }) => {
  const { t } = useTranslation(ROUTES_NS); // Get the translation function
  const { palette } = useTheme(); // Get the theme object

  return (
    <Stack direction="row" gap="30px">
      {appRoutes.map((route, index) => {
        return (
          <NavLink
            key={index}
            style={({ isActive }) => ({
              color: isActive ? palette.text.primary : palette.text.secondary,
              borderBottom: isActive ? '1px solid #1D82C0' : 'none',
              textDecoration: 'none',
              padding: '16px 0',
            })}
            to={`${route.path}`}
          >
            {t(route.labelKey as TranslationKeys)}
          </NavLink>
        );
      })}
    </Stack>
  );
};
